import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo_sgoolfotografie.svg";

function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("Fotograaf");
  const [errorMessage, setErrorMessage] = useState("");
  const [isAdminLogin, setIsAdminLogin] = useState(false);
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");

  const navigate = useNavigate();

  // Load the user email (from auth or localStorage)
  useEffect(() => {
    if (user?.email) {
      setEmail(user.email);
    } else {
      const savedEmail = localStorage.getItem("verified_email");
      if (savedEmail) {
        setEmail(savedEmail);
      }
    }

    // Check if admin login mode is set
    const adminMode = localStorage.getItem("admin_login_mode");
    if (adminMode === "true") {
      setIsAdminLogin(true);
      localStorage.removeItem("admin_login_mode"); // Clear the flag
    }
  }, [user]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!email) {
      setErrorMessage("Email not found.");
      return;
    }

    const userData = {
      username: email,
      email: email,
      roles: [selectedRole],
      organizationName: email.split("@")[1] || "Organization",
      loginTime: new Date().toISOString(),
    };

    login(userData);
    navigate("/dashboard");
  };

  const handleAdminSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");

    // Static UI - No functionality implemented yet
    // Admin authentication will be implemented later
    setErrorMessage("Admin login functionality is not yet implemented.");
  };

  const toggleLoginMode = () => {
    setIsAdminLogin(!isAdminLogin);
    setErrorMessage("");
    setAdminEmail("");
    setAdminPassword("");
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src={logo} alt="App Logo" className="logo-img" />
          <h1>Power BI Embedded</h1>
          <p>Configure your identity to access reports</p>
        </div>

        <div className="login-form-container">
          <h2>{isAdminLogin ? "Admin Sign In" : "Sign In"}</h2>
          <p className="form-description">
            {isAdminLogin
              ? "Enter your admin credentials to access all reports."
              : "Your email and selected RLS role will determine which reports you can access."}
          </p>

          {!isAdminLogin ? (
            <form onSubmit={handleSubmit} className="login-form">
              {/* READ ONLY EMAIL INPUT */}
              <div className="form-group">
                <label htmlFor="email">
                  Email Address <span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  readOnly
                  className="readonly-input"
                />
                <small>Your email is used for RLS filtering</small>
              </div>

              {/* ROLE SELECTION */}
              <div className="form-group">
                <label htmlFor="role">
                  RLS Role <span className="required">*</span>
                </label>
                <select
                  id="role"
                  name="role"
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e.target.value)}
                  className="role-select"
                  required
                >
                  <option value="Fotograaf">Fotograaf</option>
                </select>
                <small>Select the data filter to apply to your reports</small>
              </div>

              {errorMessage && <p className="error-text">{errorMessage}</p>}

              <button type="submit" className="btn">
                🔐 Sign In & View Reports
              </button>

              <div className="divider">
                <span>of</span>
              </div>

              <button
                type="button"
                onClick={toggleLoginMode}
                className="btn-secondary"
              >
                👤 Admin Login
              </button>
            </form>
          ) : (
            <form onSubmit={handleAdminSubmit} className="login-form">
              {/* ADMIN EMAIL INPUT */}
              <div className="form-group">
                <label htmlFor="admin-email">
                  Admin Email <span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="admin-email"
                  value={adminEmail}
                  onChange={(e) => {
                    setAdminEmail(e.target.value);
                    setErrorMessage("");
                  }}
                  placeholder="admin@sgoolfotografie.nl"
                  className={errorMessage ? "error-input" : ""}
                  required
                />
                <small>Enter your administrator email address</small>
              </div>

              {/* ADMIN PASSWORD INPUT */}
              <div className="form-group">
                <label htmlFor="admin-password">
                  Password <span className="required">*</span>
                </label>
                <input
                  type="password"
                  id="admin-password"
                  value={adminPassword}
                  onChange={(e) => {
                    setAdminPassword(e.target.value);
                    setErrorMessage("");
                  }}
                  placeholder="Enter password"
                  className={errorMessage ? "error-input" : ""}
                  required
                />
                <small>Enter your administrator password</small>
              </div>

              {errorMessage && <p className="error-text">{errorMessage}</p>}

              <button type="submit" className="btn">
                🔐 Sign In as Admin
              </button>

              <div className="divider">
                <span>of</span>
              </div>

              <button
                type="button"
                onClick={toggleLoginMode}
                className="btn-secondary"
              >
                ← Terug naar Gebruiker Login
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
